import {Link} from "react-router-dom";
import {ThinChevronRight} from "../icons/material-icons";

export const BreadCrumbs = (props:{links:{url:string,title:string}[]}) => {
    const t= props.links.length;
    return (
        <div className="breadcrumbs"
             //data-aos="fade-in" data-aos-delay="0" data-aos-duration="800"
        >
            <Link to={"/"}>
                <i style={{backgroundImage:`url(/logo.png)`}}/>
            </Link>
            <div>
                <ThinChevronRight/>
            </div>
            {
                props.links.map((b,i)=>
                    <div key={"Breadcrumbs"+i}>
                        <Link to={b.url}>
                            {b.title}
                        </Link>
                        {t !== (i + 1) ? <ThinChevronRight/> : null}
                    </div>
                )
            }
        </div>
    );
};